export const userEmploymentI18NDe = {
    employment: "Beschäftigung",
    startDate: "Startdatum",
    endDate: "Enddatum",
    stillEmployed: "Noch beschäftigt",
    addNew: "Neuen Zeitraum hinzufügen",
    back: "Zurück",
    present: "heute",
};
